import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CryptoJS from "crypto-js";
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
// import decryptUserCookie from './utils/decryptUserCookie';

const CatlogCategoryModal = ({ isOpen, setIsOpen, selectedCategory, setSelectedCategory, onSave, categories, setCategories, fetchCategories }) => {
    const [categoryName, setCategoryName] = useState('');
    const [position, setPosition] = useState('');
    const [status, setStatus] = useState(null);
    const [icon, setIcon] = useState("")
    const urlmain = process.env.REACT_APP_LINK
    const [images, setImages] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [category_id, setCategoryId] = useState("")
    // const userDetails = decryptUserCookie();
    const userDetails = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || "";
    const [load, setLoad] = useState(false);


    const fetchImages = async () => {
        try {
            const res = await fetch(`${urlmain}/api/images/${userDetails.main_id}`);
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };


    const handleImageSelect = (field, img) => {
        setIcon(`${urlmain}${img.url}`);
    };

    useEffect(() => {
        fetchImages();
    }, []);


    useEffect(() => {
        if (selectedCategory) {
            setCategoryId(selectedCategory.id)
            setCategoryName(selectedCategory.name);
            setPosition(selectedCategory.position);
            setIcon(selectedCategory.image);
            setStatus({ value: selectedCategory.status, label: selectedCategory.status });
        } else {
            setCategoryName('');
            setPosition('');
            setIcon('');
            setStatus(null);
        }
    }, [selectedCategory]);





    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];


    const handleSubmit = async (e) => {
        e.preventDefault();

        const categoryData = {

            name: categoryName,
            status: status?.value || 'Active',
            position,
            image: icon,
            main_id: userDetails.main_id,
            main_name: userDetails.full_name || 'Admin'
        };



        const isEdit = !!selectedCategory?.id;
        const url = isEdit
            ? `${urlmain}/catlog-category/update/${selectedCategory.id}`
            : `${urlmain}/catlog-category`;
        const method = isEdit ? "PUT" : "POST";
        setLoad(true);
        try {
            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(categoryData),
            });
            const res = await response.json();
            if (response.ok) {
                if (!isEdit) {
                    fetchCategories();
                } else {
                    setCategories(prev =>
                        isEdit
                            ? prev.map(cat => cat.id === selectedCategory.id ? { ...categoryData, id: selectedCategory.id } : cat)
                            : [...prev, { ...categoryData, id: res.id }]
                    );
                }


                setCategoryName('');
                setPosition('');
                setIcon('');
                setStatus(null);
                // fetchCategories();
                toast.success(isEdit ? "Category updated" : "Category added");
                setIsOpen(false);
                setSelectedCategory(null);

            } else {
                toast.error(res.message || "Operation failed");
            }
        } catch (error) {
            console.error("Error submitting category:", error);
            toast.error("Unexpected error occurred");
        } finally{
            setLoad(false);
        }
    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"

            >
                <h2 className="oms-modal-title">Category details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="categoryName" className="oms-form-label">
                            Category Name
                        </label>
                        <input
                            type="text"
                            id="categoryName"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Enter category name"
                        />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {
                            load ?<button type="button">Submiting...</button>:
                            <button type="submit">Submit</button>
                        }
                        
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CatlogCategoryModal;
